import { render } from "./Car.vue?vue&type=template&id=3c15a5fa&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import "./Car.vue?vue&type=style&index=0&id=3c15a5fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c15a5fa"]])

export default __exports__